<template>
  <div></div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Dashboard',
    titleTemplate: '%s - Rodonaves Iveco'
  }
}
</script>
